import { upsellPageAnalyticsRecordDbParser } from "@redotech/redo-model/one-click-upsell/upsell-page-analytics-record";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const aggregatedUpsellMetricsSchema_ = z.object({
  totalRevenue: z.number(),
  totalVisits: z.number(),
  totalAcceptedOffers: z.number(),
  totalConversionRate: z.number(),
  totalRevenuePerVisit: z.number(),
});
export const aggregatedUpsellMetricsSchema: z.ZodType<AggregatedUpsellMetrics> =
  aggregatedUpsellMetricsSchema_;
export interface AggregatedUpsellMetrics
  extends z.infer<typeof aggregatedUpsellMetricsSchema_> {}

export const getUpsellPageAnalytics = {
  name: "getUpsellPageAnalytics" as const,
  input: z.object({
    startDate: z.date(),
    endDate: z.date(),
    page: z.number().optional(),
    pageSize: z.number().optional(),
  }),
  output: z.object({
    upsellPageAnalyticsRecords: z.array(
      upsellPageAnalyticsRecordDbParser.extend({
        productName: z.string().optional(),
      }),
    ),
    ordersWithUpsell: z.array(
      z.object({
        date: zExt.instant(),
        redoOrderId: zExt.objectId(),
        orderNumber: z.string(),
        upsellAmount: z.number(),
      }),
    ),
    ordersWithUpsellTotalCount: z.number(),
    currentPeriodMetrics: aggregatedUpsellMetricsSchema,
    previousPeriodMetrics: aggregatedUpsellMetricsSchema,
  }),
};
export type GetUpsellPageAnalyticsOutput = z.infer<
  typeof getUpsellPageAnalytics.output
>;
